import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ViewInArIcon(props: IconProps) {
    return <Icon {...props} iconKey={"view_in_ar"}/>
}
